import "./auth.css";
import { ArrowLeftIcon } from "@phosphor-icons/react";
import type { ReactNode } from "react";
import { Button } from "@/components/ui/button";
import type { AuthenticationMode as AuthMode } from "./types";

export function AuthLayout({
  children,
  mode,
  onBack,
}: {
  children: ReactNode;
  mode: AuthMode;
  onBack: () => void;
}) {
  const spacing =
    mode === "sign-up" ? "p-[19px] lg:p-[47px]" : "p-[23px] lg:p-[47px]";
  const alignment =
    mode === "sign-up"
      ? "py-3 lg:py-[54px]"
      : mode === "guest"
        ? "py-6 lg:py-[126px]"
        : "py-6 lg:py-[93px]";

  return (
    <main className="auth-root relative h-[100dvh] min-h-[100dvh] overflow-hidden bg-[var(--pm-bg-canvas)] text-[var(--pm-text-primary)]">
      <img
        alt=""
        className="pointer-events-none absolute inset-0 h-full w-full object-cover"
        src="/auth/auth-background-upscaled.webp"
      />
      <div className="absolute inset-0 bg-[#131220]/8 lg:bg-transparent" />

      <div className="auth-layout relative grid h-full min-h-[100dvh] lg:grid-cols-[42.43%_57.57%]">
        <section className="auth-story relative hidden h-full px-12 pt-11 lg:block">
          <Button
            onClick={onBack}
            size="authBack"
            type="button"
            variant="authBack"
          >
            <ArrowLeftIcon size={18} weight="bold" /> Back
          </Button>
          <div className="absolute bottom-[70px] left-12 max-w-[464px]">
            <h1 className="whitespace-pre-line font-['Bricolage_Grotesque_Variable'] text-[56px] font-bold leading-none tracking-[-0.035em] text-white">
              {mode === "sign-up"
                ? "One account.\nEvery piece."
                : mode === "guest"
                  ? "Play now.\nDecide later."
                  : "Your puzzle crew\nis waiting."}
            </h1>
            <p className="mt-[18px] max-w-[464px] text-lg leading-6 text-[var(--pm-text-secondary)]">
              {mode === "sign-up"
                ? "Keep progress, your player identity, and every shared victory in one place."
                : mode === "guest"
                  ? "Guest mode gets you into the puzzle quickly, while keeping account benefits clear and honest."
                  : "Pick up where you left off, keep your streak, and bring every saved room with you."}
            </p>
          </div>
        </section>

        <section
          className={`auth-panel flex h-full min-h-0 items-start justify-center px-6 lg:pl-[50px] lg:pr-0 ${alignment}`}
        >
          <div
            className={`auth-card max-h-full w-full max-w-[456px] overflow-hidden rounded-[32px] border border-[var(--pm-border)] bg-[var(--pm-bg-raised)] shadow-[0_24px_90px_rgba(4,3,14,0.35)] ${spacing}`}
          >
            {children}
          </div>
        </section>
      </div>
    </main>
  );
}
